import "./Descriptive.css";

import { useContext, useEffect, useState } from "react";
import OTQuestionCard from "../Question";
import Attachment from "../../../../shared/Attachment";
import Divider from "../../../../shared/Divider";

import { input } from "../../helper";

import { GlobalContext } from "../../../../../context/GlobalState";
import { uploadFileToS3, getSignedURL } from "../../../../../utils/file";


export default function Descriptive({
  color = "",
  question,
  number,
  correctAnswer,
  setCorrectAnswer,
  onlineTestId,
}) {
  const { userDetails } = useContext(GlobalContext);
  const [status, setStatus] = useState("");
  const id = onlineTestId + "," + question._id;

  function setAnswer(updatedAnswer) {
    const answer = {
      ...correctAnswer,
      ...updatedAnswer,
    };
    localStorage.setItem(id, JSON.stringify(answer));
    setCorrectAnswer(answer);
  }

  async function onFileUpload(e) {
    const file = e.target.files[0];
    if (status === "uploading" || !file) return;
    setStatus("uploading");

    try {
      const { signedURL } = await getSignedURL({
        id: `students/${userDetails?.userId}/questions/${question._id}`,
        fileName: file.name,
        fileType: file.type,
      });
      await uploadFileToS3(file, signedURL);
      setAnswer({
        file: {
          name: file.name,
          link: signedURL.split("?")[0],
        },
      });
      setStatus("");
    } catch (err) {
      setStatus("error");
    }
  }

  const handleChange = (e) => {
    setAnswer({ answer: e.target.value });
  };

  useEffect(() => {
    if (window.MathJax) {
      window.MathJax.typesetPromise();
    }
    const answer = localStorage.getItem(id);
    if (!answer) return;
    setCorrectAnswer(JSON.parse(answer));
  }, []);

  return (
    <OTQuestionCard
      number={number}
      color={color}
      question={{
        label: "Hot Question",
        image: question.images?.questionImg,
        title: question?.question || "",
        signature: {
          role: question.onModel,
          teacherName: question?.creatorId?.name,
          schoolName: question?.schoolId?.name,
        },
      }}
    >
      <div className="question-input-field">
        <Attachment
          name={correctAnswer?.file?.name}
          link={correctAnswer?.file?.link}
          status={status}
          upload={onFileUpload}
        />
        <Divider />
        <textarea
          className="textarea"
          placeholder="Type your answer here..."
          style={input(color)}
          value={correctAnswer?.answer || ""}
          id="one_word_input"
          onChange={handleChange}
          readOnly={["uploading", "removing"].includes(status)}
        />
      </div>
    </OTQuestionCard>
  );
}
